import type { IFilters } from 'types';

const CATEGORY_FILTER_CODE = 'category';

export function getCategoryFilter(filters: IFilters | undefined) {
  return filters?.items?.find((filter) => filter.code === CATEGORY_FILTER_CODE);
}
